const SPEED = 0.03;

window.addEventListener('load', () => {
    const sliders = document.querySelectorAll<HTMLElement>('.usps-slider');

    sliders.forEach(slider => {
        const list = slider.querySelector<HTMLElement>('.usps-list');

        if (!list) {
            return;
        }

        const originalItems = Array.from(list.children) as HTMLElement[];

        if (originalItems.length === 0) {
            return;
        }

        let animationFrame = 0;
        let position = 0;
        let previousTime = performance.now();
        let originalWidth = 0;

        const removeClones = () => {
            list.querySelectorAll('[data-usp-clone]').forEach(clone => clone.remove());
        };

        const cloneItems = () => {
            const fragment = document.createDocumentFragment();

            originalItems.forEach(item => {
                const clone = item.cloneNode(true) as HTMLElement;
                clone.setAttribute('aria-hidden', 'true');
                clone.setAttribute('data-usp-clone', 'true');
                fragment.appendChild(clone);
            });

            list.appendChild(fragment);
        };

        const rebuild = () => {
            cancelAnimationFrame(animationFrame);
            removeClones();
            list.style.transform = '';
            position = 0;
            originalWidth = originalItems.reduce((width, item) => width + item.getBoundingClientRect().width, 0);

            if (originalWidth <= 0) {
                return;
            }

            do {
                cloneItems();
            } while (list.scrollWidth < slider.offsetWidth + originalWidth);

            previousTime = performance.now();
            animationFrame = requestAnimationFrame(animate);
        };

        const animate = (time: number) => {
            const elapsed = Math.min(time - previousTime, 50);
            previousTime = time;
            position = (position + elapsed * SPEED) % originalWidth;
            list.style.transform = `translate3d(-${position}px, 0, 0)`;
            animationFrame = requestAnimationFrame(animate);
        };

        rebuild();

        window.addEventListener('resize', rebuild);
    });
});
